__turbopack_context__.v({
  "description": "StartpageModelLinks-module-scss-module__Ya4DYq__description",
  "fade-in": "StartpageModelLinks-module-scss-module__Ya4DYq__fade-in",
  "header": "StartpageModelLinks-module-scss-module__Ya4DYq__header",
  "no-transform": "StartpageModelLinks-module-scss-module__Ya4DYq__no-transform",
  "other": "StartpageModelLinks-module-scss-module__Ya4DYq__other",
  "rotate": "StartpageModelLinks-module-scss-module__Ya4DYq__rotate",
  "section": "StartpageModelLinks-module-scss-module__Ya4DYq__section",
});
